(exports.GAME_ID = "5f8ff5894e502600178e8986"),
(exports.FORM_ID = "5f8ff59a4e502600178e8988"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-dev");